import { render, staticRenderFns } from "./toptitle.vue?vue&type=template&id=1c2a186d&scoped=true&"
import script from "./toptitle.vue?vue&type=script&lang=js&"
export * from "./toptitle.vue?vue&type=script&lang=js&"
import style0 from "./toptitle.vue?vue&type=style&index=0&id=1c2a186d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a186d",
  null
  
)

export default component.exports